import { render, staticRenderFns } from "./tags-input.vue?vue&type=template&id=1a3bc094"
import script from "./tags-input.vue?vue&type=script&lang=js"
export * from "./tags-input.vue?vue&type=script&lang=js"
import style0 from "./tags-input.vue?vue&type=style&index=0&id=1a3bc094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports